export default __webpack_public_path__ + "static/news24-7b9ad95fba895e20144d4e8c75492603.jpg";